import { ContentSection } from 'src/components/iot/IotTourModal/styles';
import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';
import { IotList } from 'src/components/iot/IotTagTooltip/components/IotList/IotList';
import { IotTargetIcon } from 'src/components/iot/icons';
import { useMemo } from 'react';
import { EIoTProviders, TIoTDevice } from 'src/components/menu-wrapper/components/iot-menu/types';
import { IotItem } from 'src/components/iot/IotTagTooltip/types';
import { CameraGridItem } from './CameraGridItem';

export const IotContent = ({
  tag,
  providers,
  setSelectedIndex,
  handleUnlock,
  selectedCameras,
  handleCameraSelect,
  unshownDevices,
  viewState,
  moveToTag,
  cameras,
  doors,
  removeCameraFromGrid,
  engines,
  things,
}) => {
  const mssqlProvider = useMemo(
    () => providers?.find((provider) => provider?.provider?.name === EIoTProviders.MS_SQL),
    [providers],
  );
  const kisiProvider = useMemo(
    () => providers?.find((provider) => provider?.provider?.name === EIoTProviders.Kisi),
    [providers],
  );

  const rhombusProvider = useMemo(
    () => providers?.find((provider) => provider?.provider?.name === EIoTProviders.RHOMBUS),
    [providers],
  );

  const tankLogixProvider = useMemo(
    () => providers?.find((provider) => provider?.provider?.name === EIoTProviders.TANKLOGIX),
    [providers],
  );

  const thingWorxProvider = useMemo(
    () => providers?.find((provider) => provider?.provider?.name === EIoTProviders.THINGWORX),
    [providers],
  );

  const { selectedDoors, sensors, engineDevices, thingWorxDevices } = useMemo(() => {
    const msSqlDevices: TIoTDevice | IotItem[] = [];
    const kisiDevices: TIoTDevice | IotItem[] = [];
    const engineDevices: TIoTDevice | IotItem[] = [];
    const thingsDevices: TIoTDevice | IotItem[] = [];

    const selectedCamerasFull = cameras?.filter((camera) => selectedCameras[0]?.id === camera.id);
    if (selectedCamerasFull?.length) {
      const doorsRelatedToCamera = selectedCamerasFull[0]?.relatedAssets
        ?.filter((a) => a.type === 'door')
        ?.map((c) => ({ ...c, onClick: () => handleUnlock(c) }));
      if (doorsRelatedToCamera?.length) {
        kisiDevices.push(...doorsRelatedToCamera);
      }
    }

    tag?.iotDevices?.forEach((device) => {
      if (device.providerId == mssqlProvider?.providerId) {
        msSqlDevices.push({ ...device, type: 'sensor' });
      }
      if (device.providerId == tankLogixProvider?.providerId) {
        const foundEngine = engines?.find((engine) => engine.id === device.id);
        engineDevices.push({ ...foundEngine, type: 'engine' });
      }
      if (device.providerId == thingWorxProvider?.providerId) {
        const foundThing = things?.find((engine) => engine.id === device.id);
        thingsDevices.push({ ...foundThing, type: 'thing' });
      }
    });

    return {
      selectedDoors: kisiDevices,
      sensors: msSqlDevices,
      engineDevices,
      thingWorxDevices: thingsDevices,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tag, kisiProvider, selectedCameras, cameras, doors, engines]);

  return (
    <>
      {!![...selectedDoors, ...sensors, ...engineDevices, ...thingWorxDevices]?.length &&
        viewState === 'band' && (
          <ContentSection>
            <Typography sx={{ fontSize: '14px', fontWeight: 700 }}>IoT</Typography>
            <IotList
              items={[...selectedDoors, ...sensors, ...engineDevices, ...thingWorxDevices]}
              settings={{
                columns:
                  [...selectedDoors, ...sensors, ...engineDevices, ...thingWorxDevices]?.length > 1
                    ? 2
                    : 1,
                lineClamp: 2,
                iconSize: 37,
                iconBorderRadius: 8,
                measureNameMaxWidth: '720px',
                compact:
                  [...selectedDoors, ...sensors, ...engineDevices, ...thingWorxDevices]?.length ===
                  1,
                itemContentSpacing: 14,
              }}
            />
          </ContentSection>
        )}
      {!!rhombusProvider && selectedCameras?.some((c) => !!c.url) && (
        <>
          <ContentSection height="100%">
            <Typography sx={{ fontSize: '14px', fontWeight: 700 }}>Media</Typography>
            {viewState === 'band' ? (
              <>
                <Box width="100%" height="100%" position="relative">
                  <iframe
                    src={selectedCameras[0].url}
                    allow="autoplay; fullscreen"
                    allowFullScreen
                    title="Embedded video"
                    style={{
                      width: '100%',
                      height: '100%',
                      borderRadius: '8px',
                      border: 'none',
                      background: 'rgba(0, 0, 0, 0.60)',
                    }}
                  />
                  <Stack position="absolute" bottom={0} right={0} gap={2} p={2} direction="row">
                    <IconButton
                      onClick={() => moveToTag(tag)}
                      sx={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '8px',
                        background: 'rgba(255, 255, 255, 0.10)',
                        backdropFilter: 'blur(20px)',
                        cursor: 'pointer',
                      }}
                    >
                      <IotTargetIcon />
                    </IconButton>
                  </Stack>
                </Box>
              </>
            ) : (
              <Grid container spacing={2}>
                {selectedCameras.map((camera, index) => {
                  return (
                    <CameraGridItem
                      camera={camera}
                      index={index}
                      setSelectedIndex={setSelectedIndex}
                      moveToTag={moveToTag}
                      cameras={cameras}
                      unshownDevices={unshownDevices}
                      handleCameraSelect={handleCameraSelect}
                      removeCameraFromGrid={removeCameraFromGrid}
                      doors={doors}
                    />
                  );
                })}
              </Grid>
            )}
          </ContentSection>
        </>
      )}
    </>
  );
};
